module.exports = __webpack_public_path__ + "static/media/composto.86baa5a6.png";